import * as React from 'react';
import { Zone, ZoneEntry } from '@ixicare/resources';

export const useZones: (props: { siteUuid?: string; planeUuid?: string }) => ZoneEntry[] = ({
  siteUuid,
  planeUuid,
}) => {
  const [zones, setZones] = React.useState<ZoneEntry[]>([]);

  React.useEffect(() => {
    // Both params are optional, but with neither the request is `GET /zones` unfiltered - every
    // zone the caller can see. No caller wants that; a caller without a site yet wants nothing.
    if (!siteUuid && !planeUuid) {
      setZones([]);
      return;
    }
    if (siteUuid && planeUuid) {
      Zone.getZones({ site: siteUuid }).then(setZones);
    } else {
      Zone.getZones({ site: siteUuid, plane: planeUuid }).then(setZones);
    }
  }, [siteUuid, planeUuid]);

  if (siteUuid && planeUuid) {
    return zones.filter((z) => z.plane_uuid === planeUuid);
  }

  return zones;
};
